import type { HelpTone } from '../types';

export const HELP_TONE_STYLES: Record<
    HelpTone,
    {
        icon: string;
        text: string;
    }
> = {
    brand: {
        icon: 'border-brand/20 bg-brand-subtle text-brand',
        text: 'text-brand',
    },
    info: {
        icon: 'border-info/20 bg-info-subtle text-info',
        text: 'text-info',
    },
    success: {
        icon: 'border-success/20 bg-success-subtle text-success',
        text: 'text-success',
    },
    warning: {
        icon: 'border-warning/25 bg-warning-subtle text-warning',
        text: 'text-warning',
    },
    youtube: {
        icon: 'border-[#ff0033]/20 bg-[#ff0033]/10 text-[#ff0033]',
        text: 'text-[#ff0033]',
    },
};
